import { type PointerEvent, type PointerEventHandler, useState } from 'react'

/** Sets `data-hovered` while the pointer is over the field itself — CSS :hover also matches while its <label> is. */
export function useFieldHover<T extends Element>(
  onPointerEnter?: PointerEventHandler<T>,
  onPointerLeave?: PointerEventHandler<T>
) {
  const [hovered, setHovered] = useState(false)

  return {
    'data-hovered': hovered || undefined,
    onPointerEnter: (event: PointerEvent<T>) => {
      setHovered(true)
      onPointerEnter?.(event)
    },
    onPointerLeave: (event: PointerEvent<T>) => {
      setHovered(false)
      onPointerLeave?.(event)
    },
  }
}
